import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useMemo } from 'react';
import styled from 'styled-components/native';
import { FieldCommentBox, StrokeCTAButton } from './AccessibilityInfoComponents';
export default function AccessibilityCommentSection({ comments, buttonText, onAddComment, elementName, registrationComments, }) {
    const sortedComments = useMemo(() => {
        const excludeSet = new Set(registrationComments !== null && registrationComments !== void 0 ? registrationComments : []);
        return [...comments]
            .filter(c => !excludeSet.has(c.comment))
            .sort((a, b) => b.createdAt.value - a.createdAt.value);
    }, [comments, registrationComments]);
    if (sortedComments.length === 0 && !onAddComment) {
        return null;
    }
    return (_jsxs(Container, { children: [sortedComments.map((c, index) => {
                var _a, _b, _c;
                return (_jsx(FieldCommentBox, { comment: c.comment, userName: (_b = (_a = c.user) === null || _a === void 0 ? void 0 : _a.nickname) !== null && _b !== void 0 ? _b : '익명 비밀요원', createdAt: c.createdAt }, (_c = c.id) !== null && _c !== void 0 ? _c : index));
            }), _jsx(StrokeCTAButton, { text: buttonText, onPress: onAddComment, elementName: elementName })] }));
}
const Container = styled.View `
  gap: 12px;
  padding-bottom: 20px;
`;
